module.exports = __webpack_public_path__ + "img/page-not-found.a4f7a725.jpg";